import { ref, watch } from "vue"

export function useCotizadorState() {

  const sinVuelo = ref(false)

  const soloDirectos = ref(false)

  const destino = ref("PUJ")

  const origen = ref("MDE")

  const telefono = ref("")

  const nombre = ref("")

  const cedula = ref("")

  const visa = ref("sin_visa")

  const modalVueloVisible = ref(false)

  const recobro = ref(false)
  const valorRecobro = ref(0)

  const filtrosOpcionales = ref([])

  // Toggle "Cancelación gratuita": solo se ofrece para viajes a 2 semanas o
  // menos; al activarlo el backend deja de aplicar el filtro fijo
  // "Cancelacion gratis" en la búsqueda de hoteles.
  const cancelacionGratuita = ref(false)


  watch(recobro, (nuevoValor) => {
    if (!nuevoValor) {
      valorRecobro.value = 0
    }
  })
  return {

    sinVuelo,

    soloDirectos,

    destino,

    origen,

    telefono,

    nombre,

    cedula,

    visa,

    modalVueloVisible,
    recobro,
    valorRecobro,
    filtrosOpcionales,
    cancelacionGratuita

  }

}